import { useRef } from "react";

import { SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";

interface DebouncedSearchInputProps {
    globalSearchLabel: string;
    onGlobalSearchChange: (value: string) => void;
    getGlobalSearchValue: () => string | undefined;
    className?: string;
}
const DEBOUNCE_TIME = 350;

export function DebouncedSearchInput({
    globalSearchLabel,
    onGlobalSearchChange,
    getGlobalSearchValue,
    className,
}: DebouncedSearchInputProps) {
    const debounceTimeout = useRef<ReturnType<typeof setTimeout>>(undefined);

    const handleSearch = (value: string) => {
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        debounceTimeout.current = setTimeout(() => {
            onGlobalSearchChange(value);
        }, DEBOUNCE_TIME);
    };

    const defaultSearchValue = getGlobalSearchValue();

    return (
        <Input
            onChange={(e) => handleSearch(e.target.value)}
            placeholder={globalSearchLabel}
            addonAfter={<SearchOutlined />}
            name="table-global-search"
            allowClear
            defaultValue={defaultSearchValue}
            className={className}
        />
    );
}
